import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import debounce from 'lodash/debounce';

import {
  Typography, Checkbox, Box
} from '@mui/material';

const ContactsTableDisplay = ({ contactType = 'operators', initialData }) => {
  
  const [data, setData] = useState(initialData);
  console.log('ContactsTable data', data);

  return (
    <div>
      {data.map((op, operatorIndex) => (
        <div key={op.operator}>
          <table border="0" cellPadding="2" style={{ borderCollapse: 'collapse', width: '100%' }}>
            <tr style={{ borderBottom: '1px solid #ccc' }}>
              <td valign="top" style={{ width: '50%'}}>
                {op.operator}
              </td>
              <td valign="top" style={{ width: '50%' }}>
                {op.contacts.length > 0 && (
                  <table border="0" cellPadding="2" style={{ borderCollapse: 'collapse', width: '100%', tableLayout: 'fixed' }}>
                    {/*<thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Designation</th>
                      </tr>
                    </thead>*/}
                    <tbody>
                      {op.contacts.map((contact, contactIndex) => {
                        const isLast = contactIndex === op.contacts.length - 1;
                        return (
                          <tr
                            key={contactIndex}
                            style={{ borderBottom: (isLast) ? 'none' : '1px solid #ccc' }}
                          >
                            {/*["name", "email", "phone"].map(field => (
                              <td key={field} style={{ width: '33%', wordWrap: 'break-word' }}>
                                {contact[field]}
                                {(field === "name") && (contact["designation"])}
                              </td>
                            ))*/}
                            <td key={"name"} style={{ width: '30%', wordWrap: 'break-word', verticalAlign: 'bottom' }}>
                              <div>{contact["name"]}</div>
                              {contact["designation"]}
                            </td>
                            <td key={"email"} style={{ width: '45%', wordWrap: 'break-word', verticalAlign: 'bottom' }}>
                              {contact["email"]}
                            </td>
                            <td key={"phone"} style={{ width: '25%', wordWrap: 'break-word', verticalAlign: 'bottom' }}>
                              {contact["phone"]}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </td>
            </tr>
          </table>
          
        </div>
      ))}
    </div>
  );
};

export default ContactsTableDisplay;
